import React from "react";
import "../styles/css/Home.css";

export default function Home() {
  return (
    <section id="home" className="hero is-fullheight-with-navbar ">
      <div className="hero-body">
        <div className="container has-text-centered has-text-dark">
          <div>
            <AnimatedLogo />
          </div>

          <h1 className="title is-1 has-text-primary">
            Faites le bon choix
            <br />
            avec Yakoi !
          </h1>
          <p className="subtitle">
            Scannez des milliers de produits alimentaires et suivez votre
            consommation
          </p>
          <div className="buttons is-centered">
            <a
              className="button is-primary"
              href="/resources/yakoi-4641170c5c6a422cb24c4417dd01e5dd-signed.apk"
              download="yakoi-4.0.apk"
            >
              <span className="icon">
                <i className="fas fa-download" />
              </span>
              <span>Télécharger</span>
            </a>
            <a
              className="button is-primary is-light"
              href="https://github.com/yakoi-l2af2-2020/yakoi"
              target="_blank"
            >
              <span className="icon">
                <i className="fab fa-github"></i>
              </span>
              <span>GitHub</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

function AnimatedLogo() {
  return (
    <svg
      id="logo"
      width="150"
      viewBox="0 0 1730 1843"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="leaf"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M831.266 324.055C796.905 355.982 751.446 379.292 695.001 394.021C655.7 406.284 612.786 412.434 566.111 412.434L510.882 408.751C510.65 407.12 510.428 405.478 510.217 403.825L486.425 407.569C457.762 410.131 431.07 408.692 406.26 403.283C370.786 397.293 341.586 385.405 318.726 367.592C297.204 348.147 280.392 321.388 268.248 287.363C258.567 263.791 252.42 237.635 249.85 208.847L249.07 174.562L282.783 169.258C311.445 166.696 338.137 168.135 362.948 173.544C398.421 179.534 427.621 191.422 450.481 209.235C477.773 232.17 497.287 265.713 509.055 309.876C509.56 303.659 510.169 297.338 510.882 290.913C520.726 202.534 548.93 135.035 595.568 88.3786C629.929 56.4519 675.388 33.142 731.832 18.4122C771.134 6.14968 814.048 0 860.723 0L915.952 3.68244L919.638 58.9191C919.638 105.576 913.481 148.513 901.241 187.805C886.531 244.256 863.23 289.698 831.266 324.055Z"
        fill="#038141"
      />
      <path
        d="M1012.23 899.716C1012.23 1179.24 785.637 1405.83 506.117 1405.83C226.596 1405.83 0 1179.24 0 899.716C0 620.196 226.596 393.6 506.117 393.6C785.637 393.6 1012.23 620.196 1012.23 899.716Z"
        fill="#F96302"
      />
      <path
        d="M1394.4 1118.88C1394.4 1332.98 1220.84 1506.54 1006.74 1506.54C792.646 1506.54 619.086 1332.98 619.086 1118.88C619.086 904.786 792.646 731.226 1006.74 731.226C1220.84 731.226 1394.4 904.786 1394.4 1118.88Z"
        fill="white"
        fill-opacity="0.33"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1281.94 1118.88C1281.94 1270.87 1158.73 1394.08 1006.74 1394.08C854.758 1394.08 731.55 1270.87 731.55 1118.88C731.55 966.897 854.758 843.689 1006.74 843.689C1158.73 843.689 1281.94 966.897 1281.94 1118.88ZM1228.31 1437.02C1165.51 1480.84 1089.13 1506.54 1006.74 1506.54C792.646 1506.54 619.086 1332.98 619.086 1118.88C619.086 904.786 792.646 731.226 1006.74 731.226C1220.84 731.226 1394.4 904.786 1394.4 1118.88C1394.4 1201.49 1368.56 1278.06 1324.53 1340.96L1709.93 1726.36C1736.48 1752.91 1736.48 1795.95 1709.93 1822.5C1683.38 1849.05 1640.34 1849.05 1613.79 1822.5L1228.31 1437.02Z"
        fill="#D6D6D6"
      />
      <g id="barcode">
        <path
          d="M858.154 1047.71H872.37V1189.85H858.154V1047.71Z"
          fill="black"
        />
        <path
          d="M872.37 1047.71H879.478V1189.85H872.37V1047.71Z"
          fill="black"
        />
        <path
          d="M893.695 1047.71H907.911V1189.85H893.695V1047.71Z"
          fill="black"
        />
        <path
          d="M915.019 1047.71H922.127V1189.85H915.019V1047.71Z"
          fill="black"
        />
        <path
          d="M929.235 1047.71H936.343V1189.85H929.235V1047.71Z"
          fill="black"
        />
        <path
          d="M943.451 1047.71H950.559V1189.85H943.451V1047.71Z"
          fill="black"
        />
        <path
          d="M957.667 1047.71H971.883V1189.85H957.667V1047.71Z"
          fill="black"
        />
        <path
          d="M971.883 1047.71H978.991V1189.85H971.883V1047.71Z"
          fill="black"
        />
        <path
          d="M986.099 1047.71H1000.32V1189.85H986.099V1047.71Z"
          fill="black"
        />
        <path
          d="M1028.75 1047.71H1038.7V1189.85H1028.75V1047.71Z"
          fill="black"
        />
        <path
          d="M1014.53 1047.71H1021.64V1189.85H1014.53V1047.71Z"
          fill="black"
        />
        <path
          d="M1042.96 1047.71H1050.07V1189.85H1042.96V1047.71Z"
          fill="black"
        />
        <path
          d="M1057.18 1047.71H1064.29V1189.85H1057.18V1047.71Z"
          fill="black"
        />
        <path d="M1071.4 1047.71H1078.5V1189.85H1071.4V1047.71Z" fill="black" />
        <path
          d="M1099.83 1047.71H1106.94V1189.85H1099.83V1047.71Z"
          fill="black"
        />
        <path
          d="M1092.72 1047.71H1115.47V1189.85H1092.72V1047.71Z"
          fill="black"
        />
        <path
          d="M1128.26 1047.71H1135.37V1189.85H1128.26V1047.71Z"
          fill="black"
        />
        <path
          d="M1142.48 1047.71H1156.69V1189.85H1142.48V1047.71Z"
          fill="black"
        />
        <path
          d="M1156.69 1047.71H1163.8V1189.85H1156.69V1047.71Z"
          fill="black"
        />
      </g>
    </svg>
  );
}
